import {
  createStudioRegistration,
} from "../Studio/StudioRegistration";

import RetailStudioAdminPanel
  from "../AdminPanel/RetailStudioAdminPanel";


export const RETAIL_STUDIO_REGISTRATION_ID =
  "retail-studio";


export const RETAIL_STUDIO_PANEL_MODE =
  "retail_studio";


export function createRetailStudioRegistration({
  loadStudioComponent =
    () => import("./RetailStudio"),

  AdminPanelComponent =
    RetailStudioAdminPanel,

  keyPrefix =
    "retail-studio",

  metadata = {},
} = {}) {
  return createStudioRegistration({
    id:
      RETAIL_STUDIO_REGISTRATION_ID,

    panelMode:
      RETAIL_STUDIO_PANEL_MODE,

    loadStudioComponent,

    AdminPanelComponent,

    keyPrefix,

    metadata: {
      domain: "retail",
      domainId: "retail",
      title: "Retail Studio",
      description:
        "Commerce / POS / vente magasin",
      icon: "🛍️",
      category: "commerce",
      status: "available",
      workbench:
        "retail-studio",
      ...metadata,
    },
  });
}


export const retailStudioRegistration =
  createRetailStudioRegistration();

export default retailStudioRegistration;
